// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1zqOO","title":"Images90_title__zDpDC","images":"Images90_images__JNQYX"};